import { useRef } from "react"
import { Separator } from '@/components/ui/separator'
import Filter from './(components)/filter'
import OverviewTable from './(components)/overview-table'
import FilterProvider from './(context)/filter'

const ClubDBPage = () => {
  const refetchRef = useRef<() => void | null>(null);

  return (
    <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
      <header>
        <h1 className='text-3xl font-bold'>Club databank</h1>
      </header>

      <Filter
        onSearch={() => refetchRef.current?.()}
      />

      <Separator />

      <OverviewTable onRefetchReady={(refetch) => (refetchRef.current = refetch)} />
    </div>
  )
}

export default () => {
  return (
    <FilterProvider>
      <ClubDBPage />
    </FilterProvider>
  )
}